<div class="container text-center">
  <div class="wrapper">
    <h3>Due to inactivity, you have been signed out of {{ appName }}.</h3>
    <p class="message">
      To protect your sensitive information we recommend that you close your browser.
    </p>
    <button color="primary" id="signin-button" lcTestId="signin-button" mat-raised-button type="button" (click)="login()">Sign In</button>
  </div>
</div>
